import { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";
import { useLocation } from "react-router-dom";
import Footer from "./Footer";

function AppLayout({ children }) {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const { pathname } = useLocation();
  const isPortalPage = pathname.startsWith("/admin") || pathname.startsWith("/instructor");

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 320);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="flex min-h-screen flex-col overflow-x-hidden">
      <div className="flex-1 pt-20">{children}</div>
      {!isPortalPage && <Footer />}
      {!isPortalPage && <button
        type="button"
        onClick={scrollToTop}
        aria-label="Scroll to top"
        // className={`fixed bottom-5 right-5 z-[9998] flex h-11 w-11 items-center justify-center rounded-full border border-white/70 bg-indigo-600 text-white shadow-[0_16px_35px_rgba(79,70,229,0.35)] ring-1 ring-indigo-500/20 transition-all duration-300 hover:-translate-y-1 hover:bg-indigo-700 hover:shadow-[0_20px_42px_rgba(79,70,229,0.42)] focus:outline-none focus:ring-2 focus:ring-indigo-300 focus:ring-offset-2 sm:bottom-6 sm:right-6 sm:h-12 sm:w-12 ${
        //   showScrollTop ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-3 opacity-0"
        // }`}
        className={`fixed bottom-5 left-1/2 -translate-x-1/2 z-[9998] flex h-11 w-11 items-center justify-center rounded-full border border-white/70 bg-indigo-600 text-white shadow-[0_16px_35px_rgba(79,70,229,0.35)] ring-1 ring-indigo-500/20 transition-all duration-300 hover:-translate-y-1 hover:bg-indigo-700 hover:shadow-[0_20px_42px_rgba(79,70,229,0.42)] focus:outline-none focus:ring-2 focus:ring-indigo-300 focus:ring-offset-2 sm:bottom-6  sm:h-12 sm:w-12 ${
          showScrollTop ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-3 opacity-0"
        }`}
      >
        <ChevronUp size={24} strokeWidth={2.5} />
      </button>}
    </div>
  );
}

export default AppLayout;
